import { styled, useTheme } from "@mui/material";
import { FunctionComponent } from "react";
import EarningsBox from "../EarningsBox";
import {
  StackedDealName,
  StackedSavingAmount,
  StackedPartnerName,
} from "./StackedTileHeader";
import {
  StandardHeader,
  Props as BaseTileHeaderProps,
  useFilterTileNames,
} from "./StandardTileHeader";

const PlainHeader = styled(StandardHeader)(({ theme }) => ({
  flexWrap: "nowrap",
  alignItems: "flex-start",
  flexDirection: "column",
  paddingTop: theme.settings.tiles.padding
    ? theme.typography.pxToRem(theme.settings.tiles.padding)
    : "0.8rem",
  paddingLeft: theme.settings.tiles.padding
    ? theme.typography.pxToRem(theme.settings.tiles.padding)
    : "0.8rem",
  paddingRight: theme.settings.tiles.padding
    ? theme.typography.pxToRem(theme.settings.tiles.padding)
    : "0.8rem",
}));

const PlainTileHeader: FunctionComponent<BaseTileHeaderProps> = ({
  id,
  item: { name, seller, deal },
}: BaseTileHeaderProps) => {
  const theme = useTheme();
  const {
    showVendorName,
    name: tileNameConfig,
    showSavingAmount,
  } = theme.settings.tiles.titleContent;
  const { dealName, listingName } = useFilterTileNames(
    tileNameConfig,
    name,
    deal?.title,
  );
  return (
    <PlainHeader id={id}>
      {showVendorName && (
        <StackedPartnerName variant="h3" noWrap title={seller.name}>
          {seller.name}
        </StackedPartnerName>
      )}
      {listingName && (
        <StackedDealName
          variant={showVendorName ? "h4" : "h3"}
          title={listingName}
        >
          {listingName}
        </StackedDealName>
      )}
      {dealName && (
        <StackedDealName
          variant={showVendorName ? "h4" : "h3"}
          title={dealName}
        >
          {dealName}
        </StackedDealName>
      )}
      {showSavingAmount && !!deal?.averageTotalSavingsAmount && (
        <StackedSavingAmount>
          <EarningsBox
            color={theme.palette.tileOthersColor.main}
            averageTotalSavingsAmount={deal.averageTotalSavingsAmount}
            averageTotalSavingsPrefix={deal.averageTotalSavingsPrefix}
            averageTotalSavingsCurrency={deal.averageTotalSavingsCurrency}
          />
        </StackedSavingAmount>
      )}
    </PlainHeader>
  );
};

export default PlainTileHeader;
